<template>
  <div class="coupon-page">
    <!-- 顶部背景与内容 -->
    <div class="header-section">
      <div class="header-bg-sky"></div>
      
      <div class="logo-bar">
        <div class="logo-icon">
          <div class="logo-sun"></div>
        </div>
        <span class="logo-text">中国石油</span>
      </div>

      <div class="title-area">
        <div class="sub-title">中国石油好客有礼</div>
        <div class="main-title">领券加油更优惠</div>
        <div class="ribbon-tag-wrapper">
          <div class="ribbon-tag">满减券限量领取 先到先得</div>
        </div>
      </div>

      <!-- CSS 绘制的加油站插图 -->
      <div class="illustration-area">
        <!-- 漂浮装饰 -->
        <div class="float-item float-1">优惠券</div>
        <div class="float-item float-2">优惠券</div>

        <div class="gas-station">
          <div class="gs-roof">
            <div class="gs-logo-icon"></div>
            <div class="gs-brand">中国石油</div>
          </div>
          <div class="gs-pillars">
            <div class="gs-pillar"></div>
            <div class="gs-pillar"></div>
            <div class="gs-pillar"></div>
          </div>
          <div class="gs-pumps">
            <div class="gs-pump"></div>
            <div class="gs-pump"></div>
          </div>
          <div class="gs-shop">
            <div class="gs-window"></div>
            <div class="gs-door"></div>
          </div>
          <div class="gs-base"></div>
        </div>
      </div>
    </div>

    <!-- 下半部分红色背景区 -->
    <div class="content-section">
      <div class="red-bg"></div>

      <!-- 表单卡片 -->
      <div class="form-card">
        <!-- 红色丝带标题 -->
        <div class="form-ribbon-wrap">
          <div class="ribbon-bg"></div>
          <div class="ribbon-main">
            <span class="ribbon-arrow">⇋</span> 输入手机号 领取满减券 <span class="ribbon-arrow">⇌</span>
          </div>
        </div>

        <div class="input-group">
          <i class="el-icon-mobile-phone"></i>
          <input
            v-model="phone"
            type="tel"
            maxlength="11"
            placeholder="请输入手机号"
          />
        </div>

        <button class="submit-btn" @click="handleReceive">
          立即领取
        </button>

        <div class="tips">券将发放至【中油好客】APP-我的卡券包</div>

        <!-- 优惠券展示卡片 -->
        <div class="coupon-card">
          <div class="coupon-left">
            <div class="coupon-tag">满减券</div>
            <div class="coupon-price">
              <span class="currency">¥</span>
              <span class="amount">10</span>
            </div>
          </div>
          <div class="coupon-right">
            <div class="c-title">满200元可用</div>
            <div class="c-desc">已存入中油好客APP卡券包</div>
            <div class="c-time">有效期：领取后7天内有效</div>
          </div>
          <div class="coupon-watermark"></div>
        </div>
      </div>

      <!-- 规则卡片 -->
      <div class="rules-card">
        <div class="rules-title">
          <span class="line"></span>
          <span class="dot"></span>
          <span class="text">活动规则</span>
          <span class="dot"></span>
          <span class="line"></span>
        </div>
        <ol>
          <li>活动时间：即日起至2025年12月31日；</li>
          <li>活动期间，每位用户仅可参与1次；</li>
          <li>优惠券限在【中油好客】APP内使用；</li>
          <li>优惠券数量有限，先到先得，领完即止；</li>
          <li>如有疑问，请咨询中油好客APP在线客服。</li>
        </ol>
      </div>

      <!-- 底部版权 -->
      <div class="footer-section">
        <div class="footer-logo-row">
          <div class="footer-logo"></div>
          <span class="footer-name">中国石油</span>
        </div>
        <div class="footer-slogan">奉献能源 创造和谐</div>
      </div>
    </div>
  </div>
</template>

<script>
import { dispatchCoupon } from '@/api/coupon'

export default {
  name: 'CouponCampaign',
  data() {
    return {
      phone: '',
      loading: false
    }
  },
  methods: {
    async handleReceive() {
      const phoneReg = /^1\d{10}$/
      if (!phoneReg.test(this.phone)) {
        this.$message.warning('请输入正确的11位手机号')
        return
      }
      
      if (this.loading) return
      this.loading = true

      try {
        const res = await dispatchCoupon(this.phone)
        
        // request.js 中已经统一拦截并提示了 code !== 200 的情况
        if (res.code === 200) {
          this.$message.success('领取成功，优惠券已发放至卡券包')
        }
      } catch (error) {
        // 错误已经在拦截器里通过 Message.error 提示过，这里只需要捕捉异常防止控制台报错
        console.error('领取失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.coupon-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  overflow-x: hidden;
  position: relative;
  max-width: 480px;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
}

/* --- 顶部区域 --- */
.header-section {
  position: relative;
  padding-top: 16px;
  min-height: 380px;
}

.header-bg-sky {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, #9ae2ff 0%, #cceeff 50%, #fff9ec 100%);
  z-index: 0;
}
/* 添加背景云彩点缀 */
.header-bg-sky::before, .header-bg-sky::after {
  content: '';
  position: absolute;
  background: rgba(255,255,255,0.6);
  border-radius: 50px;
  filter: blur(2px);
}
.header-bg-sky::before {
  width: 120px; height: 40px; top: 40px; right: -20px;
}
.header-bg-sky::after {
  width: 80px; height: 30px; top: 120px; left: -10px;
}

.logo-bar {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.logo-icon {
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.logo-sun {
  width: 14px;
  height: 14px;
  background: radial-gradient(circle, #ffca28, #f44336);
  border-radius: 50%;
}
.logo-text {
  font-size: 15px;
  font-weight: 800;
  color: #333;
}

/* 标题区 */
.title-area {
  position: relative;
  z-index: 10;
  text-align: center;
  margin-top: 16px;
}
.sub-title {
  font-size: 26px;
  font-weight: 900;
  color: #f13b22;
  letter-spacing: 2px;
  -webkit-text-stroke: 1px #fff;
  text-shadow: 1px 1px 0 #fff;
}
.main-title {
  font-size: 44px;
  font-weight: 900;
  color: #f4391b;
  margin-top: -4px;
  letter-spacing: 2px;
  -webkit-text-stroke: 2px #fff;
  text-shadow: 
    2px 2px 0 #ffe082,
    3px 3px 0 #ffca28,
    4px 4px 0 #ffb300,
    0 6px 10px rgba(200, 30, 10, 0.3);
}
.ribbon-tag-wrapper {
  margin-top: 10px;
  position: relative;
  display: inline-block;
}
.ribbon-tag {
  background: linear-gradient(90deg, #ffc530, #ff9600);
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 6px 24px;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 4px 8px rgba(255, 150, 0, 0.4);
}
.ribbon-tag::before, .ribbon-tag::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0; height: 0;
}
.ribbon-tag::before {
  left: -8px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 8px solid #ffc530;
}
.ribbon-tag::after {
  right: -8px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #ff9600;
}

/* CSS 绘制插图区 */
.illustration-area {
  position: relative;
  z-index: 10;
  height: 150px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.gas-station {
  position: relative;
  width: 300px;
  height: 100px;
  background: transparent;
  z-index: 2;
}
.gs-roof {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 24px;
  background: linear-gradient(90deg, #eb3c23, #ff573f, #eb3c23);
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(200, 30, 10, 0.2);
  z-index: 3;
}
.gs-logo-icon {
  width: 12px; height: 12px;
  background: radial-gradient(circle, #ffca28, #fff);
  border-radius: 50%;
}
.gs-brand {
  color: #fff; font-size: 12px; font-weight: bold; margin-left: 4px;
}
.gs-pillars {
  position: absolute; top: 24px; left: 20px; right: 20px;
  display: flex; justify-content: space-between;
}
.gs-pillar {
  width: 12px; height: 76px;
  background: linear-gradient(90deg, #ddd, #f5f5f5, #ccc);
}
.gs-pumps {
  position: absolute; bottom: 0; left: 40px;
  display: flex; gap: 30px; z-index: 2;
}
.gs-pump {
  width: 20px; height: 36px;
  background: linear-gradient(180deg, #f4391b, #d32f2f);
  border-radius: 4px 4px 0 0;
  position: relative;
}
.gs-pump::before {
  content: ''; position: absolute;
  top: 6px; left: 4px; right: 4px; height: 10px;
  background: #fff; border-radius: 2px;
}
.gs-shop {
  position: absolute; bottom: 0; right: 40px;
  width: 80px; height: 50px;
  background: #fdfdfd; border: 1px solid #eee;
  display: flex; align-items: flex-end; justify-content: center; gap: 8px;
}
.gs-window { width: 30px; height: 26px; background: #bdf; margin-bottom: 10px; }
.gs-door { width: 18px; height: 32px; background: #9cd; }
.gs-base {
  position: absolute; bottom: -8px; left: -10px; right: -10px;
  height: 8px; background: linear-gradient(180deg, #e0e0e0, #aaa);
  border-radius: 4px; z-index: 1;
}

/* 浮动点缀 */
.float-item {
  position: absolute;
  background: #ffebc2;
  color: #d84524;
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  animation: floatAnim 3s infinite ease-in-out;
}
.float-1 { top: 20px; left: 20px; transform: rotate(-15deg); }
.float-2 { top: 40px; right: 20px; transform: rotate(10deg); animation-delay: 1.5s; }
@keyframes floatAnim {
  0%, 100% { transform: translateY(0) rotate(-10deg); }
  50% { transform: translateY(-10px) rotate(5deg); }
}

/* --- 下半部分区域 --- */
.content-section {
  position: relative;
  z-index: 10;
  padding: 20px 16px 30px;
  margin-top: -20px;
}
.red-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, #ff4c3b 0%, #e22814 100%);
  z-index: 0;
}

/* 表单卡片 */
.form-card {
  position: relative;
  z-index: 2;
  background: linear-gradient(180deg, #fffdf4, #ffedd1);
  border-radius: 16px;
  padding: 40px 16px 20px;
  box-shadow: 0 8px 20px rgba(200, 30, 10, 0.3);
  margin-bottom: 20px;
}

.form-ribbon-wrap {
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  width: 86%;
  text-align: center;
}
.ribbon-bg {
  position: absolute;
  top: 10px; left: -8px; right: -8px; height: 32px;
  background: #bd1703;
  border-radius: 16px;
  z-index: 1;
}
.ribbon-main {
  background: linear-gradient(90deg, #ff5e44, #e82c14, #ff5e44);
  color: #fff;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  font-size: 17px;
  font-weight: bold;
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 6px rgba(200, 30, 10, 0.3);
}
.ribbon-arrow {
  opacity: 0.6;
  font-weight: normal;
  margin: 0 4px;
}

.input-group {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #f2e2cf;
  border-radius: 24px;
  padding: 0 16px;
  height: 50px;
}
.input-group i {
  color: #b0b0b0;
  font-size: 22px;
  margin-right: 10px;
}
.input-group input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #333;
  background: transparent;
}
.input-group input::placeholder {
  color: #bbb;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #ff8c45, #f4391b);
  border: none;
  border-radius: 25px;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin-top: 16px;
  box-shadow: 0 6px 16px rgba(244, 57, 27, 0.4), inset 0 2px 2px rgba(255,255,255,0.3);
  cursor: pointer;
  transition: transform 0.1s;
}
.submit-btn:active {
  transform: scale(0.98);
}

.tips {
  text-align: center;
  color: #8c6a51;
  font-size: 13px;
  margin-top: 12px;
}

/* 优惠券卡片 */
.coupon-card {
  position: relative;
  display: flex;
  margin-top: 20px;
  background: linear-gradient(90deg, #fff7ea, #fff1dc);
  border-radius: 12px;
  border: 1px solid #fce3c5;
  box-shadow: inset 0 0 10px rgba(255, 230, 200, 0.6);
  overflow: hidden;
}
/* 优惠券边缘凹槽 */
.coupon-card::before, .coupon-card::after {
  content: '';
  position: absolute;
  left: 32%;
  width: 16px; height: 16px;
  background: #fffdf4; /* 匹配表单卡片背景 */
  border-radius: 50%;
  transform: translateX(-50%);
  z-index: 5;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);
}
.coupon-card::before { top: -8px; }
.coupon-card::after { bottom: -8px; }

.coupon-left {
  width: 32%;
  min-width: 100px;
  border-right: 2px dashed #f5c898;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
}
.coupon-tag {
  background: #ffecd6;
  color: #f45e23;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  margin-bottom: 6px;
  font-weight: bold;
}
.coupon-price {
  color: #f13b22;
  font-weight: bold;
}
.currency { font-size: 20px; margin-right: 2px; }
.amount { font-size: 42px; line-height: 1; }

.coupon-right {
  flex: 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 2;
}
.c-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
}
.c-desc {
  font-size: 12px;
  color: #7a5c44;
  margin-bottom: 4px;
}
.c-time {
  font-size: 12px;
  color: #9c8069;
}
/* 卡片底纹水印 */
.coupon-watermark {
  position: absolute;
  right: -20px; bottom: -20px;
  width: 80px; height: 80px;
  background: radial-gradient(circle, transparent 40%, rgba(245, 200, 152, 0.2) 41%, rgba(245, 200, 152, 0.2) 60%, transparent 61%);
  border-radius: 50%;
  z-index: 1;
}

/* 规则卡片 */
.rules-card {
  position: relative;
  z-index: 2;
  background: rgba(255, 245, 235, 0.95);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}
.rules-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f13c20;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}
.rules-title .line {
  width: 30px; height: 1px;
  background: #f13c20; margin: 0 8px; opacity: 0.5;
}
.rules-title .dot {
  width: 4px; height: 4px;
  background: #f13c20; border-radius: 50%; opacity: 0.5;
}
.rules-title .text { margin: 0 8px; }
.rules-card ol {
  color: #8c604b;
  font-size: 13px;
  line-height: 1.8;
  padding-left: 18px;
  margin: 0;
}

/* 底部版权 */
.footer-section {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 10px 0;
}
.footer-logo-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.footer-logo {
  width: 16px; height: 16px;
  background: radial-gradient(circle, #ffca28, #f44336);
  border-radius: 50%;
  margin-right: 6px;
}
.footer-name {
  color: #ffd6cd;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
}
.footer-slogan {
  color: #ffb7ab;
  font-size: 12px;
  letter-spacing: 2px;
}
</style>
